import { Tabs } from "antd";
import React, { useEffect, useState } from "react";
import liracrypt from "../components/Liracrypt/liracrypt";
import allRoutes from "../routes/latestRoutes";

import { useLocation } from "react-router-dom";
import queryString from 'query-string';
import RoutePage from "../components/RoutePage";
const TaioPage = ({ urlEndpoint, setPageHeader, pageName, urlData = {} }) => {
  const { search } = useLocation();
  const searchParams = queryString.parse(search);

  const { TabPane } = Tabs;
  const [selectedTabIndex, setSelectedTabIndex] = useState("0");
  const [tabLoading, setTabLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [configData, setConfigData] = useState();

  useEffect(() => {
    setLoading(true);
    liracrypt
      .get(urlEndpoint, { ...searchParams, ...urlData })
      .then((res) => {

        setConfigData(res.data.config);
        if (setPageHeader) {
          setPageHeader(res.data.config.pageTitle || pageName);
        }
        let defaultTab = Object.values(res.data.config.tabData).findIndex(
          (x) => x.isDefault === true
        );
        setSelectedTabIndex(defaultTab);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [JSON.stringify(searchParams)]);

  const routeComponent = (x, tab) => {
    let __route = x.route.split('/v02/:urlCode');
    __route = __route[1].split('/:');
    return tab?.route === __route[0]
  };

  const getRouteData = (tab) => {
    let component = allRoutes.find((x) => routeComponent(x, tab))?.component;
    let __urlData = { ...tab?.params };
    let defaultParams = {
      ...searchParams,
      ...urlData,
      tabid: tab?.tabid
    }
    __urlData = { ...defaultParams, ...tab?.params }
    return component ? (
      component({ urlData: __urlData })
    ) : (
      <p
        style={{
          color: "#e74c3c",
        }}
      >
        No Route Found in latestRoutes.js
      </p>
    );
  };

  const getTab = (tabIndex) => {
    return Object.values(configData?.tabData)[tabIndex]
  }

  return (
    !loading && (
      <div className="taioPage">
        {configData?.tabData && (
          <>
            <Tabs
              className="taio-tabs"
              activeKey={selectedTabIndex.toString()}
              type="line"
              tabPosition={"top"}
              onChange={(activeKey) => {
                setTabLoading(true);
                setSelectedTabIndex(activeKey);
                setTimeout(() => {
                  setTabLoading(false);
                }, 100);
              }}
            >
              {Object.keys(configData?.tabData).map((tabKey, index) => {
                let tab = configData?.tabData[tabKey];
                return (
                  tab.visible && (
                    <TabPane
                      disabled={!tab?.enable}
                      tab={tab?.tabName}
                      key={index}
                    ></TabPane>
                  )
                );
              })}
            </Tabs>
            <RoutePage
              loading={tabLoading}
              route={getTab(selectedTabIndex).route} params={{
                ...searchParams,
                ...urlData,
                ...getTab(selectedTabIndex)?.params,
                tabid: getTab(selectedTabIndex)?.tabid
              }} />
            {/* {getRouteData(Object.values(configData?.tabData)[selectedTabIndex])} */}
          </>
        )}
      </div>
    )
  );
};

export default TaioPage;
